"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.object.entries.js");

var _ecc = require("../ecc");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var MultiSessionTempData =
/*#__PURE__*/
function () {
  function MultiSessionTempData(_ref) {
    var key = _ref.key,
        accounts = _ref.accounts;

    _classCallCheck(this, MultiSessionTempData);

    this.key = key;
    this.accounts = accounts;
  }

  _createClass(MultiSessionTempData, [{
    key: "getVal",
    value: function getVal(account, field) {
      var defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (this.accounts[account]) return this.accounts[account][field] || defaultVal;
      return defaultVal;
    }
  }, {
    key: "setVal",
    value: function setVal(account, field, val) {
      this.accounts[account] = this.accounts[account] || {};
      this.accounts[account][field] = val;
      this.accounts[account]._created = Date.now();
      return this;
    }
  }, {
    key: "addKey",
    value: function addKey(account, authType, val) {
      if (val && val.toWif) val = val.toWif();

      try {
        _ecc.PrivateKey.fromWif(val);
      } catch (e) {
        val = _ecc.PrivateKey.fromSeed(account + authType + val).toString();
      }

      return this.setVal(account, authType, val);
    }
  }, {
    key: "addMultiAuth",
    value: function addMultiAuth(account) {
      return this.setVal(account, 'multiauth', true);
    }
  }, {
    key: "clearExpired",
    value: function clearExpired() {
      var expirationMsec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3600000;
      var nowMsec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var onClear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      nowMsec = nowMsec || Date.now();

      var cleared = function cleared(acc, deltaMsec) {
        var defaultLog = true;

        if (onClear) {
          var info = {
            acc: acc,
            deltaMsec: deltaMsec
          };

          var _onClear = onClear(info),
              log = _onClear.log;

          if (log) {
            log(info);
            defaultLog = false;
          }
        }

        if (defaultLog) console.log('MultiSessionTempData cleared', deltaMsec);
      };

      for (var _i = 0, _Object$entries = Object.entries(this.accounts); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            acc = _Object$entries$_i[0],
            data = _Object$entries$_i[1];

        if (data._created) {
          var deltaMsec = nowMsec - data._created;

          if (deltaMsec >= expirationMsec) {
            delete this.accounts[acc];
            cleared(acc, deltaMsec);
          }
        }
      }

      return this;
    }
  }, {
    key: "logout",
    value: function logout(account) {
      delete this.accounts[account];
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.accounts = {};
      return this;
    }
  }, {
    key: "save",
    value: function save() {
      var json = JSON.stringify({
        accounts: this.accounts
      });
      var buf = new Buffer(json).toString('hex');
      sessionStorage.setItem(this.key, buf);
      return this;
    }
  }]);

  return MultiSessionTempData;
}();

module.exports = MultiSessionTempData;